import { EmptyState, SettingsIcon } from '@forge/common';

const UnderConstructionPage = () => (
  <div className="flex items-center justify-center" style={{ minHeight: '60vh' }}>
    <EmptyState
      icon={<SettingsIcon />}
      title="Page Under Construction"
      description="This page is being built. Check back soon."
    />
  </div>
);

export default UnderConstructionPage;
